import styled from "@emotion/styled";
import Colors from "styles/colors";
import { SUBMENU_BORDER, sectionHeaderStyles, textLinkItemStyles } from "../submenu-shared.scss";
export const StyledSolutionsSubmenuComponent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors["white"]};

  .section-header {
    ${sectionHeaderStyles}
  }

  .solutions-section {
    padding: 25px 0;
    flex-shrink: 0;
    border-top: ${SUBMENU_BORDER};
    display: flex;
    flex-direction: column;
    gap: 8px;

    &:first-child {
      padding: 32px 0;
      border-top: none;
    }
  }

  .text-item {
    ${textLinkItemStyles}
  }

  .icon-item {
    display: flex;
    align-items: center;
    gap: 12px;
    height: 40px;
    text-decoration: none;

    .item-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      flex-shrink: 0;

      svg {
        width: 20px;
        height: 20px;
      }
    }

    .item-label {
      font-size: 1rem;
      font-weight: 400;
      color: ${Colors["Black"]};

      &--product {
        font-weight: 500;
      }
    }

    &:hover .item-label {
      color: ${Colors["brand-iris"]};
    }
  }
`;
